import Dexie, { Table } from 'dexie';

export interface HistoryEntry {
  _id: string;
  timestamp: number;
  content: any;
  hasBeenTransferredSuccessfully: boolean;
  resultCode: number;
}

export class HistoryDb extends Dexie {
  public history!: Table<HistoryEntry>;

  constructor() {
    super('historyFDM');

    this.version(1).stores({
      history: '_id, timestamp',
    });
  }
}

export const historyDb = new HistoryDb();
